export function VerveIcon({ style }) {
  return (
    <>
      <svg
        viewBox='0 -227 750 750'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
      >
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='verve' fillRule='nonzero'>
            <rect
              id='Rectangle-path'
              fill='#00425F'
              x='0'
              y='0'
              width='750'
              height='295.450012'
              rx='20'
            ></rect>
            <g id='Group' transform='translate(66.000000, 35.000000)'>
              <circle
                id='Oval'
                fill='#EE312A'
                cx='107.5'
                cy='107.5'
                r='107.5'
              ></circle>
              <path
                d='M107.499995,153.362725 C83.4681523,98.8873337 65.8448492,48 65.8448492,48 L29,48 C29,48 51.4257509,113.317063 93.080897,195 L121.919103,195 C163.574249,113.317063 186,48 186,48 L149.155141,48 C149.155141,48 131.531838,98.8873337 107.499995,153.362725 Z'
                id='Shape'
                fill='#FFFFFF'
              ></path>
              <path
                d='M621.113436,146.540569 L549.314677,146.540569 C549.314677,146.540569 550.909818,170.666883 582.820685,170.666883 C598.775608,170.666883 614.731728,165.837988 614.731728,165.837988 L617.923246,191.567306 C617.923246,191.567306 601.967125,198 579.629297,198 C547.719572,198 519,181.918591 519,136.891995 C519,101.513298 541.3365,79 573.247544,79 C621.113436,79 624.304953,127.243281 621.113436,146.540569 Z M571.652504,101.513298 C550.909771,101.513298 549.314677,124.026597 549.314677,124.026597 L593.989005,124.026597 C593.989005,124.026597 592.39391,101.513298 571.652504,101.513298 Z'
                id='Shape'
                fill='#FFFFFF'
              ></path>
              <path
                d='M373.214385,108.623324 L378,83.0294396 C378,83.0294396 341.041315,71.783453 311,92.627117 L311,195 L342.906457,195 L342.903941,111.822332 C355.665024,102.224785 373.214385,108.623324 373.214385,108.623324 Z'
                id='Shape'
                fill='#FFFFFF'
              ></path>
              <path
                d='M286.113913,146.540569 L214.315713,146.540569 C214.315713,146.540569 215.910841,170.666883 247.82146,170.666883 C263.776259,170.666883 279.730937,165.837988 279.730937,165.837988 L282.922429,191.567306 C282.922429,191.567306 266.967761,198 244.630107,198 C212.719312,198 184,181.918591 184,136.891995 C184,101.513298 206.337654,79 238.248449,79 C286.113913,79 289.30405,127.243281 286.113913,146.540569 Z M236.652039,101.513298 C215.910795,101.513298 214.315713,124.026597 214.315713,124.026597 L258.989693,124.026597 C258.989693,124.026597 257.394601,101.513298 236.652039,101.513298 Z'
                id='Shape'
                fill='#FFFFFF'
              ></path>
              <path
                d='M451,156.605781 C441.05272,132.406506 433.027561,107.460679 426.999064,82 L395,82.0042285 C395,82.0042285 411.000193,143.797279 438.202963,195 L463.797037,195 C490.999826,143.797279 507,82.0156194 507,82.0156194 L475.000936,82.0156194 C468.971104,107.470841 460.945967,132.411374 451,156.605781 Z'
                id='Shape'
                fill='#FFFFFF'
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
}
